var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"scroll-top"},[_c('BaseButton',{staticClass:"scroll-top__icon",attrs:{"size":"auto"},nativeOn:{"click":function($event){return _vm.scrollTop()}}},[_c('i',{staticClass:"fa-light fa-chevron-up"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }